import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareG = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler7') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler7', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Boss pet!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Boss pet!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareG}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareG
  
